import { render } from "./domain-list.vue?vue&type=template&id=9a2afd22&scoped=true"
import script from "./domain-list.vue?vue&type=script&lang=js"
export * from "./domain-list.vue?vue&type=script&lang=js"

import "./domain-list.vue?vue&type=style&index=0&id=9a2afd22&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2afd22"]])

export default __exports__